var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61345",
    "data-name": "Group 61345",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.015,
    height: 26.012,
    viewBox: "0 0 26.015 26.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15824",
    "data-name": "Path 15824",
    d: "M25.295,25.377H25.3v-9.54c0-4.667-1-8.262-6.461-8.262a5.664,5.664,0,0,0-5.1,2.8h-.076V8.01H8.489V25.376h5.387v-8.6c0-2.264.429-4.453,3.233-4.453,2.763,0,2.8,2.584,2.8,4.6v8.455Z",
    transform: "translate(0.714 0.635)",
    fill: "#fd930d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15825",
    "data-name": "Path 15825",
    d: "M.4,7.977H5.79V25.343H.4Z",
    transform: "translate(0.031 0.669)",
    fill: "#fd930d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15826",
    "data-name": "Path 15826",
    d: "M3.124,0A3.138,3.138,0,1,0,6.248,3.124,3.125,3.125,0,0,0,3.124,0Z",
    transform: "translate(0)",
    fill: "#fd930d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e31beb43f05b603b9a7a35e0de8b686c.svg";
export { ForwardRef as ReactComponent };